import { Store } from "vuex";
import { getModule } from "vuex-module-decorators";
import { LoginUser } from "../store/modules/loginUser";
import { Companies } from "../store/modules/companies";
import { Departments } from "../store/modules/departments";
import { Employees } from "../store/modules/employees";
import { Histories } from "../store/modules/histories";
import { OperationLogs } from "../store/modules/operationLogs";

let LoginUserStore: LoginUser;
let CompaniesStore: Companies;
let DepartmentsStore: Departments;
let EmployeesStore: Employees;
let HistoriesStore: Histories;
let OperationLogsStore: OperationLogs;

function initializeStores(store: Store<any>): void {
  LoginUserStore = getModule(LoginUser, store);
  CompaniesStore = getModule(Companies, store);
  DepartmentsStore = getModule(Departments, store);
  EmployeesStore = getModule(Employees, store);
  HistoriesStore = getModule(Histories, store);
  OperationLogsStore = getModule(OperationLogs, store);
}

export {
  initializeStores,
  LoginUserStore,
  CompaniesStore,
  DepartmentsStore,
  EmployeesStore,
  HistoriesStore,
  OperationLogsStore,
};
